<template>
  <div class="mini-plan">
    <img :src="IMG_URL + 'mini-building.png'" alt />
  </div>
</template>

<script>
import { IMG_URL } from 'src/constants';

export default {
  name: 'mini-plan',
  data() {
    return {
      IMG_URL,
    };
  },
};
</script>
